import { render, staticRenderFns } from "./CiteButton.vue?vue&type=template&id=035d1054&scoped=true"
import script from "./CiteButton.vue?vue&type=script&lang=js"
export * from "./CiteButton.vue?vue&type=script&lang=js"
import style0 from "./CiteButton.vue?vue&type=style&index=0&id=035d1054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d1054",
  null
  
)

export default component.exports